import React, { useState, useCallback, useContext, createContext } from 'react';
// FIX: We must import the component under a different name to avoid recursive naming
import ToastDisplay from '../components/ui/ToastContainer.jsx';

const ToastContext = createContext(null);

// This is the provider component that will wrap your entire application.
// It holds the state and logic for displaying toasts.
export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState(null);

  const showToast = useCallback((message, type = 'success', duration = 5000) => {
    setToast({ message, type, id: Date.now(), duration });
  }, []);

  // Object-style API used by DashboardOverview and other modern components
  const addToast = useCallback(({ type = 'success', message, duration = 5000 }) => {
    showToast(message, type, duration);
  }, [showToast]);

  const hideToast = useCallback(() => {
    setToast(null);
  }, []);

  const value = { showToast, addToast, hideToast };

  return (
    <ToastContext.Provider value={value}>
      {children}
      {/* The UI for the toast is rendered here, listening for changes */}
      {/* CRITICAL FIX: Pass the hideToast function down as a prop */}
      <ToastDisplay toast={toast} onHide={hideToast} />
    </ToastContext.Provider>
  );
};

// This is the custom hook that your components will use to access the showToast function.
export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};